import { render } from "./CreateClientDetails.vue?vue&type=template&id=a8d9a99e&scoped=true"
import script from "./CreateClientDetails.vue?vue&type=script&lang=js"
export * from "./CreateClientDetails.vue?vue&type=script&lang=js"

import "./CreateClientDetails.vue?vue&type=style&index=0&id=a8d9a99e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d9a99e"]])

export default __exports__